// extracted by mini-css-extract-plugin
export default {"button":"FabItem__button___jriaI","iconWrapper":"FabItem__iconWrapper___asjlm"};